export default class ListIterator {
    constructor(startNode) {
        this.currentNode = null;
        this.startNode = startNode;
    };

    getData() {
        return (this.currentNode == null ? null : this.currentNode.data);
    };

    setData(value) {
        if (this.currentNode != null) {
            this.currentNode.data = value;
        }
    };

    next() {
        var result;
        if (this.currentNode == null) {
            if (this.startNode != null) {
                this.currentNode = this.startNode;
                result = this.currentNode.data;
            }
        }
        else if (this.currentNode.next != null) {
            this.currentNode = this.currentNode.next;
            result = this.currentNode.data;
        }
        return result;
    };

    previous() {
        var result;

        if (this.currentNode == null) {
            result = null;
        }
        else if (this.currentNode.previous != null) {
            this.currentNode = this.currentNode.previous;
            result = this.currentNode.data;
        }
        return result;
    };

    hasNext() {
        var result;

        if (this.currentNode == null) {
            result = (this.startNode != null);
        }
        else {
            result = (this.currentNode.next != null);
        }
        return result;
    };

    hasPrevious() {
        var result;

        if (this.currentNode == null) {
            result = false;
        }
        else {
            result = (this.currentNode.previous != null);
        }
        return result;
    };

    start() {
        this.currentNode = null;
    };
}